import { validateNumber } from 'ember-changeset-validations/validators';

export const ChannelPromotionEarlyBookingValidation = {
  value: [validateNumber({ gt: 0, lte: 75 })],
  minAdvanceDays: [validateNumber({ gte: 60, lte: 500 })],
};

export const ChannelPromotionLastMinuteValidation = {
  value: [validateNumber({ gt: 0, lte: 75 })],
  maxAdvanceDays: [validateNumber({ gte: 0, lte: 30 })],
};

export const ChannelPromotionNewListingValidation = {
  value: [validateNumber({ gt: 0, lte: 75 })],
};

export const ChannelPromotionMobileOnlyValidation = {
  value: [validateNumber({ gt: 0, lte: 75 })],
};

export const ChannelPromotionMemberOnlyValidation = {};
